export default function ValidatorService()
{
    const email = (email : string) =>
    {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };

    const phoneNumber = (number: string) =>
    {
        const regex = /\(\d{2}\)\s\d{4,5}-?\d{4}/g;
        return regex.test(number);
    };

    const cpf = (cpf: string) =>
    {
        cpf = cpf.replace(".", "").replace(".", "").replace("-", "");
    
        let soma = 0;
        let resto;
        
        if (cpf == "00000000000") return false;
         
        for (let i = 1; i <= 9; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
        
        resto = (soma * 10) % 11;
       
        if ((resto == 10) || (resto == 11)) resto = 0;
        if (resto != parseInt(cpf.substring(9, 10)) ) return false;
       
        soma = 0;

        for (let i = 1; i <= 10; i++) soma = soma + parseInt(cpf.substring(i-1, i)) * (12 - i); 
        
        resto = (soma * 10) % 11;
       
        if ((resto == 10) || (resto == 11)) resto = 0;
        if (resto != parseInt(cpf.substring(10, 11) )) return false;
    
        return true;
    };

    return {
        email,
        phoneNumber,
        cpf
    };
}